<div class="container">
  <div fxLayout="row" fxLayout.lt-md="column" class="history-heading">
    <div fxFlex>
      <h2 class="header m-0 history-header">History</h2>
      <span>{{ attributeName }}</span>
    </div>
  </div>

  <div>
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="happenedOn">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element">
          <span class="ts">
            {{ element.happenedOn | date: 'medium' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.firstName }} {{ element.lastName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="from">
        <th mat-header-cell *matHeaderCellDef>Change From</th>
        <td mat-cell *matCellDef="let element">
          <ul class="property-list">
            @for (prop of element.properties; track prop) {
              <li class="property-list-item">
                {{ prop.oldValue ?? 'No value' }}
              </li>
            }
          </ul>
        </td>
      </ng-container>

      <ng-container matColumnDef="to">
        <th mat-header-cell *matHeaderCellDef>Change To</th>
        <td mat-cell *matCellDef="let element">
          <ul class="property-list">
            @for (prop of element.properties; track prop) {
              <li class="property-list-item">
                {{ prop.newValue ?? 'No value' }}
              </li>
            }
          </ul>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [length]="dataSource.rowCount$ | async"
      [pageSize]="DEFAULT_PAGE_SIZE"
      class="mat-paginator-sticky"
    ></mat-paginator>
  </div>
</div>
